import { styled } from 'linaria/react';
import { css } from 'linaria';

export const HeaderContainer = styled.div`
  margin-bottom: var(--space-150);
`;

export const SelectionGroupItemClassname = css`
  &[type='button'] {
    margin: 0;
  }
`;

export const SelectionGroupClassname = css`
  display: flex;
  gap: var(--space-200);

  @media (--only-mobile) {
    gap: var(--space-150);
  }
`;

export const IconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--control-secondary);
  border-radius: 27px;
`;
